import {
defineCustomElement,
MediaMenuElement,
MediaMenuButtonElement,
MediaMenuItemsElement
} from "vidstack/elements";

defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuItemsElement);